<script>
import Faker from 'faker'

const PRIVATE_KEYS = ["definitions", "fake", "locale", "localeFallback", "locales", "helpers"]
export default {

  props: {
    value: {}
  },

  data() {
    return {
      internalValue: this.value
    }
  },

  methods: {
    fetchFakerOptions(object, carry="Faker"){
      let result = []
      for (let [key, value] of Object.entries(object)) {
        if (PRIVATE_KEYS.indexOf(key) >= 0) { continue }

        if (typeof value == "object") {
          result.push(...this.fetchFakerOptions(value, `${carry}.${key}`))
        } else if(typeof value == "function") {
          result.push(`${carry}.${key}`)
        }
      }
      return result
    }
  },

  computed: {
    fakerOptions() {
      return this.fetchFakerOptions(Faker).filter((s) => {
        return s.startsWith(this.internalValue)
      })
    }
  },

  watch: {
    internalValue() {
      this.$emit('input', this.internalValue)
    }
  }
}

</script>

<template>
  <b-autocomplete
    v-model="internalValue"
    :data="fakerOptions"
  >
  </b-autocomplete>
</template>